// extracted by mini-css-extract-plugin
export default {"horizentalScroll":"FullLocationInputs_horizentalScroll__z57SW"};